import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import { Button } from "@/components/ui/button";

const IntegrationsTab = () => {
  const integrations = [
    { title: "Email Service (SMTP)", desc: "Send emails and notifications" },
    { title: "SMS Gateway", desc: "Send SMS notifications" },
    { title: "Cloud Storage", desc: "Store documents and files" },
  ];

  return (
    <Card className="border-none shadow-sm">
      <CardHeader className="border-b border-gray-50 pb-3">
        <CardTitle className="text-lg font-bold">
          Third-Party Integrations
        </CardTitle>
        <p className="text-xs font-medium tracking-tight text-gray-500">
          Connect with external services and platforms
        </p>
      </CardHeader>
      <CardContent className="space-y-4 pt-6">
        {integrations.map((item, idx) => (
          <Card
            key={idx}
            className="border border-gray-100 shadow-none transition-colors hover:border-gray-200"
          >
            <CardContent className="flex items-center justify-between p-5">
              <div className="space-y-1">
                <p className="text-sm font-bold text-gray-800">{item.title}</p>
                <p className="text-xs font-medium tracking-tight text-gray-400">
                  {item.desc}
                </p>
              </div>
              <Button
                variant="outline"
                className="h-8 border-gray-200 px-4 text-xs font-bold hover:bg-gray-50"
              >
                Configure
              </Button>
            </CardContent>
          </Card>
        ))}
      </CardContent>
    </Card>
  );
};

export default IntegrationsTab;
